import { Link, useLocation } from "react-router";
import { TaskInformationField } from "../TaskInformationField";
import { Task } from "../../../types/task";
import { parseTaskDate } from "../../../utils/calendarUtils";
import { UseFormRegister } from "react-hook-form";
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';

interface Props {
    task: Task;
    showRecordatorioTimes: boolean;
    register: UseFormRegister<Task>;
}

export function Information({ task, register, showRecordatorioTimes }: Props) {
    const location = useLocation();

    const fechaInicio = task ? parseTaskDate(task?.fechaInicial, task?.horaInicial) : "Sin fecha de inicio.";
    const fechaFin = task ? parseTaskDate(task?.fechaFinal, task?.horaFinal) : "Sin fecha de fin.";

    const fecha = fechaInicio == fechaFin ? fechaInicio : `${fechaInicio} - ${fechaFin}`;

    return (
        <div className="flex flex-col gap-y-3">
            <TaskInformationField
                texto={
                <Link
                    className="w-fit" 
                    to={`/empresa/${task?.empresaId}`}
                    state={{ fromName: "calendario (tareas)", fromPath: location.pathname }}>
                    <p className="font-medium">{task.empresaName}</p>
                </Link>}
                nombreCampo="Empresa"
                icono={<BusinessRoundedIcon sx={{ height: 23, width: 23, color: "#475569" }}/>}/>

            <TaskInformationField
                texto={<p className="font-semibold">{fecha}</p>}
                nombreCampo="Fecha"
                icono={<FlagRoundedIcon sx={{ height: 23, width: 23, color: "#475569" }}/>}/>

            <TaskInformationField
                texto={
                    <div>
                        <p
                            className="font-semibold rounded-full text-center w-[100px]"
                            style={{
                                backgroundColor: task.estatus == "Terminada" ? "#818cf8" : "#86efac",
                            }}>
                            {task.estatus}
                        </p>
                    </div>
                }
                nombreCampo="Estatus"
                icono={<CheckCircleRoundedIcon sx={{ height: 22, width: 22, color: "#475569" }}/>}/>

            <TaskInformationField
                texto={<p className="font-semibold">Gustavo Luna</p>}
                nombreCampo="Creado por"
                icono={<Person2RoundedIcon sx={{ height: 23, width: 23, color: "#475569" }}/>}/>

            <TaskInformationField
                texto={
                    <div className="flex items-center gap-x-2">
                        <label htmlFor="recordatorio" className="font-semibold">Habilitar</label>
                        <input
                            {...register("recordatorioActivado")}
                            id="recordatorio"
                            type="checkbox" />
                    </div>
                }
                nombreCampo="Recordatorio"
                icono={<NotificationsRoundedIcon sx={{ height: 23, width: 23, color: "#475569" }}/>}/>

            {showRecordatorioTimes && (
            <div className="flex items-center gap-x-2">
                <div className="w-[23px] h-[23px]"></div>
                <p className="text-slate-700 font-semibold text-sm">Enviar recordatorio</p>
                <select
                    {...register("timeBeforeSendNotification", {
                        validate: (value, form) => {
                            return form.recordatorioActivado && 
                                value != undefined &&
                                value.toLocaleString().length > 0;
                        }
                    })}
                    className="font-semibold text-sm bg-transparent">
                    <option value="" hidden>Seleccionar tiempo</option>
                    <option value={30}>30 minutos antes</option>
                    <option value={60}>1 hora antes</option>
                    <option value={1440}>1 dia antes</option>
                </select>
            </div>
            )}

        </div>
    );
}